import { render } from "./intermedio.vue?vue&type=template&id=ceb8b0ac&scoped=true"
import script from "./intermedio.vue?vue&type=script&lang=js"
export * from "./intermedio.vue?vue&type=script&lang=js"

import "./intermedio.vue?vue&type=style&index=0&id=ceb8b0ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb8b0ac"]])

export default __exports__